import React from "react";
import {cx} from "../../../lib/ClassSet";
import "./ProductSurchargeItem.css";

const ProductSurchargeItem = (props) => {

  let {data} = props;

  let classes = cx({
    "item": true,
    "sales-shop-product-surcharge-item": true,
    "u-selected": props.selected
  })

// Copy from ProductItem
  let surcharge = data.get("surcharge").map(x => {
    return (
      <span key={x.get("currency")} className="f-surcharge-item">
        <span className="currency">{x.get("currency")}</span>
        <span className="value">{x.get("value")}</span>
      </span>
    )
  })


  return (
    <tr className={classes} onClick={(e) => props.onClick(data, e)}>
      <td className="field f-sku">{data.get("productSku")}</td>
      <td className="field">{data.get("countryName")}</td>
      <td className="field">{data.get("stateName")}</td>
      <td className="field f-surcharge">{surcharge}</td>
    </tr>
  )
}

export default ProductSurchargeItem;